"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _SidebarItem = _interopRequireDefault(require("./SidebarItem"));
var _variables2 = _interopRequireDefault(require("@/styles/variables.scss"));
var _HamburgerLine = _interopRequireDefault(require("@/components/HamburgerLine"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    SidebarItem: _SidebarItem.default,
    HamburgerLine: _HamburgerLine.default
  },
  data: function data() {
    return {
      currentUrlMatched: '',
      openeds: []
    };
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['permission_routes', 'sidebar'])), {}, {
    showRouter: function showRouter() {
      var router = {};
      // for (const item of this.$store.getters.permission_routes) {
      //   if (item.path === this.currentUrlMatched) {
      //     router = item.children
      //     break
      //   } else if (item.path === '/') {
      //     router = item.children
      //   }
      // }
      router = this.$store.getters.permission_routes;
      this.openeds = [];
      // this.openeds = router.map((item)=>{
      //   if(!item.hiiden){
      //     return item.path
      //   }
      // })
      console.log('路由路由==', router);
      return router;
    },
    activeMenu: function activeMenu() {
      var route = this.$route;
      console.log(' this.$route', this.$route);
      var meta = route.meta,
        path = route.path;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo: function showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables: function variables() {
      return _variables2.default;
    },
    isShowCollapse: function isShowCollapse() {
      return this.sidebar.isShow;
    },
    isCollapse: function isCollapse() {
      return !this.sidebar.opened;
    }
  }),
  watch: {
    $route: {
      handler: function handler(val) {
        this.currentUrlMatched = val.matched ? val.matched[0].path : val.path;
        this.isShowSideBar();
        // console.log('currentUrlMatched', this.currentUrlMatched, 'router', val)
      },
      // 深度观察监听
      deep: true
    }
  },
  created: function created() {
    this.currentUrlMatched = this.$route.matched ? this.$route.matched[0].path : this.$router.path;
    this.isShowSideBar();
    // console.log('currentUrlMatched', this.currentUrlMatched, 'router', this.$route)
  },
  methods: {
    toggleSideBar: function toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar');
    },
    isShowSideBar: function isShowSideBar() {
      // if (this.currentUrlMatched === ''|| this.currentUrlMatched == '/manuals'
      // || this.currentUrlMatched == '/trainning' ||this.currentUrlMatched == '/qms'
      // || this.currentUrlMatched == '/safetyMgt' ||this.currentUrlMatched == '/crewMgt'
      // || this.currentUrlMatched == '/navigation' || this.currentUrlMatched == '/operation'
      // || this.currentUrlMatched == '/auditAndInspection' || this.currentUrlMatched == '/tech'
      // || this.currentUrlMatched == '/ems' || this.currentUrlMatched == '/incidents'
      // || this.currentUrlMatched == '/emergency'|| this.currentUrlMatched == '/tmsa'
      // || this.currentUrlMatched == '/analysis' || this.currentUrlMatched == '/cert'
      // || this.currentUrlMatched == '/info' || this.currentUrlMatched == '/hrAndMgt'
      // || this.currentUrlMatched == '/accounts' || this.currentUrlMatched == '/sqemsAdmin') {
      //   this.$store.dispatch('app/isShowSideBar', false)
      // } else {
      this.$store.dispatch('app/isShowSideBar', true);
      // }
    }
  }
};